import { Outlet } from "react-router-dom";
import USER_ROLES from "../../types/UserRoles";
import { useGetRole } from "../hooks/getRole";
import { NotFound } from "../../pages/NotFound";

export const SystemUsers = () => {
  const [role] = useGetRole();

  return role !== USER_ROLES.INTEGRATION_RECEPTIONIST ? (
    <Outlet />
  ) : (
    <NotFound />
  );
};
